<template>
  <div>
    <v-btn
      v-for="(item, i) in items.slice(0, large ? items.length : 3)"
      :key="i"
      fab
      class="ma-2"
      :large="large"
      color="info"
      :href="item.href"
      target="_blank"
      
      
      
    >
      <v-icon
        dark
        v-text="item.icon"
      />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    large: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    items: [
      {
        name: 'youtube',
        icon: 'mdi-youtube',
        href: "https://www.youtube.com/channel/UCwObEOZR1mUk3DBFBhUSbFQ"
        
      },
      {
        name: 'discord',
        icon: 'mdi-discord',
        href: 'https://discord.gg/WevHKwG'
      },
      {
        name: 'Medium',
        icon: 'mdi-medium',
        href: 'https://medium.com/@cryptorootz'
      },
  

    ]
  })
}
</script>
